import tw from 'twin.macro';

import { PlusIcon } from '@heroicons/react/24/outline';
import {
  UseFormRegister,
  FieldErrors,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
} from 'react-hook-form';

import { Button } from '@/components/base';

import QuestionForm from './QuestionForm';
import { TemplateFormValues, emptyQuestion } from '../types';

type Props = {
  fields: { id: string }[];
  register: UseFormRegister<TemplateFormValues>;
  errors: FieldErrors<TemplateFormValues>;
  isViewOnly: boolean;
  append: UseFieldArrayAppend<TemplateFormValues, 'questions'>;
  remove: UseFieldArrayRemove;
};

const QuestionList = ({ fields, register, errors, isViewOnly, append, remove }: Props) => {
  return (
    <div tw="flex flex-col gap-3">
      <div tw="flex items-center justify-between">
        <h6 tw="font-semibold text-gray-700">คำถาม ({fields.length})</h6>
        {!isViewOnly && (
          <Button
            type="button"
            variant="info"
            isSmall
            onClick={() => append(emptyQuestion())}
            tw="flex items-center gap-1 px-3 py-1.5 text-sm"
          >
            <PlusIcon tw="w-4 h-4" />
            เพิ่มคำถาม
          </Button>
        )}
      </div>

      {fields.length === 0 ? (
        <div tw="border-2 border-dashed border-gray-200 rounded-xl py-10 flex flex-col items-center justify-center gap-2 text-gray-400">
          <p tw="text-sm">ยังไม่มีคำถาม</p>
          {!isViewOnly && (
            <button
              type="button"
              tw="text-sm text-primary hover:underline"
              onClick={() => append(emptyQuestion())}
            >
              เพิ่มคำถามแรก
            </button>
          )}
        </div>
      ) : (
        fields.map((field, index) => (
          <QuestionForm
            key={field.id}
            index={index}
            register={register}
            errors={errors}
            isViewOnly={isViewOnly}
            onRemove={() => remove(index)}
          />
        ))
      )}
    </div>
  );
};

export default QuestionList;
